var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockTime2Selected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.4,
    height: 16.4,
    viewBox: "0 0 16.4 16.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock-time2",
    transform: "translate(-16.3 -16.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons8-countdown-clock",
    d: "M12,4A7.991,7.991,0,0,0,5.6,7.2V5.8a.6.6,0,1,0-1.2,0V8.6a.6.6,0,0,0,.6.6H7.8A.6.6,0,1,0,7.8,8H6.5a6.8,6.8,0,1,1-1.3,4A.6.6,0,1,0,4,12a8,8,0,1,0,8-8Z",
    transform: "translate(12.5 12.5)",
    fill: "#fd581f",
    stroke: "#fd581f",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18906",
    "data-name": "Path 18906",
    d: "M237.977,111.482h-2.708a.6.6,0,0,1-.6-.6v-3.611a.6.6,0,1,1,1.2,0v3.009h2.107a.6.6,0,1,1,0,1.2Z",
    transform: "translate(-211.033 -85.152)",
    fill: "#fd581f",
    stroke: "#fd581f",
    strokeWidth: 0.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockTime2Selected);
export default __webpack_public_path__ + "static/media/clock-time2-selected.711386e268401cf98102e0f39b9fb6f5.svg";
export { ForwardRef as ReactComponent };